import React from 'react';

const WALL_COPY = {
  photo_request: {
    eyebrow: 'Photos are a member perk',
    title: 'Sign up to unlock photo access',
  },
  nsfw_request: {
    eyebrow: 'For members only',
    title: 'That part of the conversation starts after signup',
  },
  preview_limit: {
    eyebrow: "You've hit the limit",
    title: 'Keep going with a free account',
  },
  rate_limited: {
    eyebrow: 'Slow down a little',
    title: 'Too many messages in a row — just wait a moment',
  },
};

const GuestPreviewSignupWall = ({ reason, message, onSignup, onLogin }) => {
  const copy = WALL_COPY[reason] || WALL_COPY.preview_limit;

  return (
    <div className="rounded-2xl border border-rose-200 bg-gradient-to-br from-rose-50 to-white p-4 shadow-sm">
      <p className="text-xs font-semibold uppercase tracking-[0.18em] text-rose-500">
        {copy.eyebrow}
      </p>
      <h3 className="mt-2 text-lg font-semibold text-slate-900">
        {copy.title}
      </h3>
      <p className="mt-2 text-sm leading-6 text-slate-600">
        {message}
      </p>
      <div className="mt-4 flex flex-col gap-2 sm:flex-row">
        <button
          type="button"
          onClick={onSignup}
          className="inline-flex h-11 items-center justify-center rounded-xl bg-gradient-to-r from-rose-500 to-pink-500 px-4 text-sm font-semibold text-white shadow-sm transition hover:from-rose-600 hover:to-pink-600"
        >
          Create free account
        </button>
        <button
          type="button"
          onClick={onLogin}
          className="inline-flex h-11 items-center justify-center rounded-xl border border-slate-200 bg-white px-4 text-sm font-semibold text-slate-700 transition hover:border-rose-200 hover:bg-rose-50"
        >
          Log in
        </button>
      </div>
    </div>
  );
};

export default GuestPreviewSignupWall;
